import React, { useState } from 'react';
import Swal from 'sweetalert2';
import AdminModal from './AdminModal';
import AdminForm from './AdminForm';
import { useCreateAdmin } from '../../hooks/useAdmins';

const AddAdmin = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    image: null
  });

  const createAdminMutation = useCreateAdmin();

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await createAdminMutation.mutateAsync(formData);
      onClose();
      setFormData({ name: '', email: '', password: '', image: null });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Admin created successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error creating admin:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to create admin',
        confirmButtonText: 'OK',
        background: '#ffffff',
        color: '#333',
        customClass: {
          popup: 'rounded-lg shadow-xl',
          confirmButton: 'bg-[#dc2626] text-white font-bold py-2 px-4 rounded',
          cancelButton: 'bg-[#6b7280] text-white font-bold py-2 px-4 rounded',
        }
      });
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', email: '', password: '', image: null });
    onClose();
  };

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Admin"
    >
      <AdminForm 
        formData={formData}
        onFormChange={handleFormChange}
        onSubmit={handleFormSubmit}
        isEdit={false}
        isMutating={createAdminMutation.isPending}
        selectedAdmin={null}
        onCancel={handleCancel}
      />
    </AdminModal>
  );
};

export default AddAdmin; 